import React from "react";
import type { KgFileIconProps } from "./KgFileIcon.types";

/** File icon for artifact overview Format row (Figma `file`, 16px). */
export const KgFileIcon: React.FC<KgFileIconProps> = ({
  size = 16,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M9.33333 1.33325H4C3.26362 1.33325 2.66667 1.93021 2.66667 2.66659V13.3333C2.66667 14.0696 3.26362 14.6666 4 14.6666H12C12.7364 14.6666 13.3333 14.0696 13.3333 13.3333V5.33325L9.33333 1.33325Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33333 1.33325V5.33325H13.3333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KgFileIcon;
